import * as React from 'react';
import DropComponent from '../components/DropComponent';
import { Switch, Route } from 'react-router-dom';
import { History, Location } from 'history';

import {
  getStoreState,
  subscribeToStoreState,
  storeDispatch,
  getStage,
  getRenderer
} from '../state/Store';
import * as Actions from '../state/actions';
import { cloneObject, generateClassName, isMobileLayout } from '../utils';
import Examples from '../examples';
import { ModalManager } from '../components/ModalManager';
import { AlertView } from '../components/AlertView';

import { Editor } from './Editor';
import { AccountSettings } from '../account';
import FourOFour from '../404';
import Buy from '../buy';
import { Library } from '../library';
import { canUseWebGL } from '../utils/index';
import TopBar from './TopBar';
import { AppSumo } from '../modals/AppSumo';
import { TopBarMobile } from './TopBarMobile';
import { PlatformType } from 'data/PlatformType';

interface Props {
  location: Location;
  history: History;
}

interface State {
  isMobile: boolean;
}

export default class extends React.Component<Props, State> {
  previousLocation: Location | undefined;
  // didPush: boolean;
  constructor(props: Props) {
    super(props);

    this.state = {
      isMobile: isMobileLayout()
    };

    subscribeToStoreState(this.storeDidUpdate);
    window.addEventListener('resize', () => {
      this.setState({
        isMobile: isMobileLayout()
      });
    });
  }

  // componentDidCatch(error, info) {
  //   // Display fallback UI
  //   // this.setState({ hasError: true }); // show: something went wrong!
  //   // You can also log the error to an error reporting service
  //   // logErrorToMyService(error, info);
  // }

  componentDidUpdate(prevProps: Props) {
    if (
      ['/buy', '/library', '/examples', '/account'].includes(
        this.props.location.pathname
      )
    ) {
      return;
    }
    this.previousLocation = cloneObject(this.props.location);
  }

  storeDidUpdate = () => {
    // TODO: this could be somewhere else
    const appState = getStoreState().app;
    const { isPlaying } = getStoreState().flyer;
    if (!isPlaying) {
      const stage = getStage();
      if (stage) {
        getRenderer().render(stage);
      }
    }
    this.forceUpdate(() => {
      if (appState.error) {
        alert(appState.error);
        storeDispatch({ type: Actions.SHOWN_ERROR });
      }
    });
  };

  showMobileMenu = () => {
    alert('Show mobile menu!');
  };

  render() {
    const appState = getStoreState().app;
    // const flyerState = getStoreState().flyer;
    // const isRecording =
    //   appState.flowState === FlowState.Recording && appState.recorder !== null;
    let location = this.props.location;
    const showExamplesModal = location.pathname === '/examples';
    const showAccount = location.pathname === '/account';
    const showBuyModal = location.pathname === '/buy';
    const showLibraryModal = location.pathname === '/library';
    if (showExamplesModal || showBuyModal || showLibraryModal) {
      location = this.previousLocation ?? this.props.location;
    }
    const isShowingOverlay: boolean =
      showExamplesModal ||
      showBuyModal ||
      showLibraryModal ||
      appState.alerts.length > 0 ||
      appState.openedModals.length > 0;

    const hideTopBarButton = showAccount;
    let needsToRegisterFirst = location.pathname.startsWith('/appsumo');

    /* const showJoyride = false;
      appState.tourIndex > -1 &&
      !isShowingOverlay &&
      ((flyerState.motionSource && flyerState.motionSource.hasAudio) ||
        flyerState.layers.length > 0);*/
    return (
      <DropComponent
        className={generateClassName('app', {
          recording: false,
          hasOverlay: isShowingOverlay,
          figmaPlugin: appState.isBeatflyerLite
        })}
      >
        {!appState.isBeatflyerLite &&
          !needsToRegisterFirst &&
          (this.state.isMobile || appState.platform === PlatformType.iOSApp ? (
            <TopBarMobile
              history={this.props.history}
              flyerId={getStoreState().flyer.id}
              onShowMenu={this.showMobileMenu}
              hideButtons={hideTopBarButton}
            />
          ) : (
            <TopBar
              disabled={appState.controllerHasConfirmation}
              hideButtons={hideTopBarButton}
              history={this.props.history}
            />
          ))}
        {canUseWebGL() && (
          <Switch location={location}>
            <Route exact={true} path="/" component={Editor} />
            <Route path="/examples/:id" component={Editor} />
            <Route path="/flyers/:uid/:id" component={Editor} />
            <Route path="/template/:id" component={Editor} />
            <Route path="/templates/:category" component={Editor} />
            <Route path="/account" component={AccountSettings} />
            <Route path="/appsumo/:id" component={AppSumo} />
            {this.previousLocation === undefined && (
              <Route path="/buy" render={props => null} />
            )}
            <Route component={FourOFour} />
          </Switch>
        )}

        {showExamplesModal && (
          <Route exact={true} path="/examples" component={Examples} />
        )}
        {showBuyModal && <Route exact={true} path="/buy" component={Buy} />}
        {showLibraryModal && (
          <Route exact={true} path="/library" component={Library} />
        )}
        {appState.openedModals.length > 0 && (
          <ModalManager modals={appState.openedModals} />
        )}
        {appState.alerts.length > 0 && (
          <AlertView data={appState.alerts[appState.alerts.length - 1]} />
        )}
      </DropComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/index.tsx